import React, { useState,useMemo, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Channels.css';
import {  useNavigate } from 'react-router-dom';
import {
  Table,
  Form,
  Dropdown,
  ButtonGroup,
  Button,
  InputGroup,
} from 'react-bootstrap';
import { Globe } from 'lucide-react';
import { list_channels } from '../../../utils/crm_services';
import { currencyFormatter } from '../../../utils/services';
import New_channel from './modals/New_channel';
import Modal_proyectos from '../../menus/Modal';
import Select, { components } from 'react-select';
import ChannelsWorldMap from './ChannelsWorldMap';
import { isGoldChannel } from './channel_utils';

const colMap = {
  channelName: 'Reseller Name',
  pipeline: 'Current Pipeline',
  wonSales: 'Won Sales',
  country: 'Country',
  agent: 'Sales Agent',
  opportunities: 'Open Opportunities',
};

function Channels  ({user_id, permission, usr_type}) {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'dollar_amount', dir: 'desc' });
    const [initialRows, setinitialRows] = useState([ ]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isMapOpen, setMapOpen] = useState(false);

    const [recordCount, setrecordCount] = useState(false);
    const token = localStorage.getItem("token");

    const [selectedTier, setSelectedTier] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [selectedOwners, setSelectedOwners] = useState([]);

    const tierOptions = [
        { label: 'Tier 1', value: 1 },
        { label: 'Tier 2', value: 2 },
        { label: 'Tier 3', value: 3 },
      ];
  

        useEffect(() => {
          fetchloadChannel(token);
        }, [token]); 

      async function fetchloadChannel(token) {
                const channelData = await list_channels(token);
                if (channelData==="INVALID"){
                    navigate("/");
                }
                else{
                  if(channelData!=null){
                  const tempCH = channelData.map((celement, index) => {
                    return {
                      id: celement.id,
                      name: celement.name,
                      tier: celement.tier,
                      country: celement.country,
                      owner_name: celement.owner_name,
                      dollar_amount: celement.dollar_amount,
                      won_dollar_amount: celement.won_dollar_amount,
                      total_session_duration: celement.total_session_duration,
                      CAS_since: celement.CAS_since ?? celement.cas_since ?? null,
                      index:index
                    };
                  });
                  setinitialRows(tempCH);
                }
                }
          }

           const CustomMultiValueLabel = (props) => {
            const { data, innerProps, selectProps } = props;
            const originalLabel = data.label;
            const maxLength = 4; // Define el número máximo de caracteres que quieres mostrar
          
            // Aplica el truncamiento si la etiqueta es más larga que maxLength
            const truncatedLabel = originalLabel.length > maxLength
              ? originalLabel.substring(0, maxLength) + '.'
              : originalLabel;
          
            return (
              <components.MultiValueLabel {...props}>
                {truncatedLabel}
              </components.MultiValueLabel>
            );
          };
          
          
    // --- Filtrado + ordenamiento memoizados ---
    const countryOptions = useMemo(() => {
      const uniqueCountries = Array.from(new Set(initialRows.map((row) => row.country).filter(Boolean)));
      return uniqueCountries.map((country) => ({ label: country, value: country }));
    }, [initialRows]);

    const ownerOptions = useMemo(() => {
      const uniqueOwners = Array.from(new Set(initialRows.map((row) => row.owner_name).filter(Boolean)));
      return uniqueOwners.map((owner) => ({ label: owner, value: owner }));
    }, [initialRows]);

    const rows = useMemo(() => {
      let result = initialRows;

      if (selectedTier.length > 0) {
        result = result.filter((r) => {
          const tierValue = Number(r.tier);
          if (!Number.isNaN(tierValue)) {
            return selectedTier.includes(tierValue);
          }
          return selectedTier.includes(r.tier);
        });
      }
  
      if (selectedCountries.length > 0) {
        result = result.filter((r) => selectedCountries.includes(r.country));
      }

      if (selectedOwners.length > 0) {
        result = result.filter((r) => selectedOwners.includes(r.owner_name));
      }

      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        result = result.filter((r) =>
          Object.values(r).some((v) => String(v).toLowerCase().includes(term))
        );
      }
  
      result = [...result].sort((a, b) => {
        const aGold = isGoldChannel(a) ? 1 : 0;
        const bGold = isGoldChannel(b) ? 1 : 0;
        if (aGold !== bGold) return bGold - aGold;

        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        if (sortConfig.key === 'dollar_amount' || sortConfig.key === 'won_dollar_amount' || sortConfig.key === 'total_session_duration'){
            aVal = parseFloat(aVal);
            bVal = parseFloat(bVal);
        }
        
        if (aVal === bVal) return 0;
        const order = aVal > bVal ? 1 : -1;
        return sortConfig.dir === 'asc' ? order : -order;
      });

      setrecordCount(result.length);
  
      return result;
    }, [searchTerm, sortConfig, initialRows, selectedTier, selectedCountries, selectedOwners]);
  
    // --- Handlers ---
    const toggleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
        }
        return { key, dir: 'asc' };
      });
    };
  
    const getTierByValue = (values) => {
    if (!Array.isArray(values)) {
      return []; // Ensure it's always an array for multi-select
    }
    return tierOptions.filter(option => values.includes(option.value));
  };

  const getOptionsByLabel = (values, options) => {
    if (!Array.isArray(values)) {
      return [];
    }
    return options.filter((option) => values.includes(option.value));
  };

  const hasValidCASSince = (casSince) => {
    if (casSince === null || casSince === undefined) return false;
    const normalizedDate = String(casSince).trim();
    return normalizedDate !== '' && normalizedDate !== '0000-00-00' && normalizedDate.toLowerCase() !== 'null';
  };
 
    // Icono flecha ↑↓
    const SortIcon = ({ col }) =>
      sortConfig.key === col ? (sortConfig.dir === 'asc' ? '↑' : '↓') : '↕';
  
    // ---------- UI ----------
    return (
      
      <div className="container-fluid py-4">

        <Modal_proyectos isOpen={isModalOpen} onClose={() => setModalOpen(false)} 
              title='New Reseller'
          >  
               <New_channel token={token} onSet={() => setModalOpen(false)}></New_channel>
                 
    </Modal_proyectos>

        {isMapOpen && (
        <Modal_proyectos
          isOpen={isMapOpen}
          onClose={() => setMapOpen(false)}
          title="Resellers por país"
          contentClassName="modal-content2--channels-map"
        >
          <ChannelsWorldMap
            channels={initialRows}
            usrType={usr_type}
            onChannelClick={(channelId) => {
              setMapOpen(false);
              navigate(`/channel_panel?chid=${channelId}`);
            }}
          />
        </Modal_proyectos>
        )}

        <div className="d-flex align-items-center justify-content-between gap-3 mb-4 channels-page-title">
          <h1 className="mb-0 fw-bold">TOMi Resellers</h1>
          <Button
            variant="outline-primary"
            className="channels-map-open-btn d-flex align-items-center justify-content-center"
            onClick={() => setMapOpen(true)}
            title="Ver mapa por país"
            aria-label="Ver mapa por país"
          >
            <Globe size={22} strokeWidth={2} />
          </Button>
        </div>
  
        {/* Barra de búsqueda + menús */}
        <div className="d-flex gap-2 mb-3 flex-wrap">
          <InputGroup className="flex-grow-1" style={{ maxWidth: 320 }}>
            <Form.Control
              placeholder="Search all columns..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='toolbar-control'
            />
          </InputGroup>

          <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      options={tierOptions}
                      isLoading={tierOptions.length === 0}
                      // --- Key Change: Add isMulti prop ---
                      isMulti
                      // --- Key Change: onChange now receives an array of selected options ---
                      onChange={(selectedOptions) => {
                        // `selectedOptions` will be an array of objects: [{ value: 10, label: 'Stage 10%' }, ...]
                        // Map it to just the values to store in your state
                        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                        setSelectedTier(values); // Update your state with the array of selected values
                      }}
                      placeholder="Tier..."
                      // --- Key Change: value should now be an array of selected option objects ---
                      value={getTierByValue(selectedTier)}
                      components={{
                        MultiValueLabel: CustomMultiValueLabel,
                      }}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          minWidth: 100,
                          flex: 1,
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999
                        })
                      }}
                    />

          <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      options={countryOptions}
                      isLoading={countryOptions.length === 0}
                      isMulti
                      onChange={(selectedOptions) => {
                        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                        setSelectedCountries(values);
                      }}
                      placeholder="Country..."
                      value={getOptionsByLabel(selectedCountries, countryOptions)}
                      components={{
                        MultiValueLabel: CustomMultiValueLabel,
                      }}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          minWidth: 120,
                          flex: 1,
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999
                        })
                      }}
                    />

          <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      options={ownerOptions}
                      isLoading={ownerOptions.length === 0}
                      isMulti
                      onChange={(selectedOptions) => {
                        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                        setSelectedOwners(values);
                      }}
                      placeholder="Owner..."
                      value={getOptionsByLabel(selectedOwners, ownerOptions)}
                      components={{
                        MultiValueLabel: CustomMultiValueLabel,
                      }}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          minWidth: 120,
                          flex: 1,
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999
                        })
                      }}
                    />


     
        <h2 className="mb-4 fw-bold">
          {recordCount}
          </h2>
        </div>

  
        {/* Tabla */}
        <Table hover responsive className="align-middle">
          <thead className="table-light">
            <tr >
                {parseInt(usr_type) === 0 && (
                <th className="channel-gold-badge-col" aria-label="Canal especial" />
                )}
                <th onClick={() => toggleSort('channelName')} role="button">
                  Reseller Name <SortIcon col="channelName" />
                </th>
           
                {parseInt(usr_type)==0 && (
                <th onClick={() => toggleSort('dollar_amount')} role="button">
                  Current Pipeline <SortIcon col="dollar_amount" />
                </th>
                )}
                {parseInt(usr_type)==0 && (
                <th onClick={() => toggleSort('won_dollar_amount')} role="button">
                  Won Sales <SortIcon col="won_dollar_amount" />
                </th>
                )}
                 {parseInt(usr_type)==0 && (
                <th onClick={() => toggleSort('total_session_duration')} role="button">
                  Demo hours <SortIcon col="total_session_duration" />
                </th>
                 )}
                  {parseInt(usr_type)==0 && (
                <th onClick={() => toggleSort('tier')} role="button">
                  Tier <SortIcon col="tier" />
                </th>
                 )}
                <th onClick={() => toggleSort('country')} role="button">
                  Country <SortIcon col="country" />
                </th>
             
                <th onClick={() => toggleSort('agent')} role="button">
                  Owner <SortIcon col="agent" />
                </th>
            
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              const goldChannel = parseInt(usr_type) === 0 && isGoldChannel(row);
              const rowClassName = [
                hasValidCASSince(row.CAS_since) ? 'cas-channel-row' : '',
                goldChannel ? 'gold-channel-row' : '',
              ].filter(Boolean).join(' ');

              return (
              <tr
                key={row.id}
                onClick={() => navigate(`/channel_panel?chid=${row.id}`)}
                className={rowClassName}
              >
                {parseInt(usr_type) === 0 && (
                <td className="channel-gold-badge-col">
                  {goldChannel && (
                    <span
                      className="channel-gold-medal"
                      title="Canal especial: pipeline > $1M, WON > $300K, demo > 100 h"
                      aria-label="Canal especial"
                    />
                  )}
                </td>
                )}
                <td>{row.name}</td>
                {parseInt(usr_type)==0 && (
                <td>{currencyFormatter.format(row.dollar_amount)}</td>
                )}
                {parseInt(usr_type)==0 && (
                <td>{currencyFormatter.format(row.won_dollar_amount)}</td>
                )}
                {parseInt(usr_type)==0 && (
                <td>{Intl.NumberFormat('es-CO', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(parseInt(row.total_session_duration) / 60)}</td>
                )}
                <td>{row.tier}</td>
                <td>{row.country}</td>
                <td>{row.owner_name}</td>
                </tr>
              );
            })}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan="10" className="text-center py-4">
                      No results
                    </td>
                  </tr>
                )}
          </tbody>
        </Table>
        {parseInt(usr_type)==0 && (
          <Button
            variant="primary"
            className="floating-add-button"
            onClick={() => setModalOpen(true)}
          >
            +
          </Button>
        )}
      </div>
    );
};

export default Channels;
